var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { XbpmContext } from '@unitarius/xbpm-runtime';
import fileDownload from 'js-file-download';
import { FormUtils } from '@unitarius/xbpm-runtime';
var FileService = /** @class */ (function () {
    function FileService() {
        var _this = this;
        this.getFileName = function (resp) {
            var header = resp.headers['content-disposition'] || '';
            var startIdx = header.indexOf('"') + 1;
            var endIdx = header.lastIndexOf('"');
            return header.substring(startIdx, endIdx) || 'file';
        };
        this.downloadFile = function (resp, fileName) {
            return fileDownload(resp.data, fileName || _this.getFileName(resp));
        };
        this.fetchFileData = function (config) {
            return _this.httpClient
                .request(__assign({ responseType: 'blob', method: 'get' }, config))
                .catch(FormUtils.result.throwHttpError(''));
        };
        this.getFileUrl = function (config) {
            return _this.fetchFileData(__assign(__assign({}, config), { responseType: 'blob' })).then(function (_a) {
                var data = _a.data;
                return URL.createObjectURL(data);
            });
        };
        this.getFile = function (config, fileName) {
            return _this.fetchFileData(__assign(__assign({}, config), { responseType: 'blob' })).then(function (resp) { return _this.downloadFile(resp, fileName); });
        };
    }
    Object.defineProperty(FileService.prototype, "httpClient", {
        get: function () {
            return XbpmContext.getContext().apiService.httpClient;
        },
        enumerable: false,
        configurable: true
    });
    return FileService;
}());
export { FileService };
//# sourceMappingURL=file.service.js.map